
export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-brain-line',
      title: 'AI 기반 퍼널 설계',
      description: '머신러닝 알고리즘이 업종별 성공 사례를 분석하여 최적의 마케팅 퍼널을 자동으로 설계합니다.',
      image: 'https://public.readdy.ai/ai/img_res/fa4859892cd2ff3fcece186f1f817135.jpg'
    },
    {
      icon: 'ri-target-line',
      title: '타겟 고객 세분화',
      description: '고객 데이터를 분석하여 정확한 타겟 세그먼트를 식별하고 맞춤형 마케팅 메시지를 생성합니다.',
      image: 'https://readdy.ai/api/search-image?query=Customer%20segmentation%20visualization%20with%20diverse%20people%20icons%2C%20target%20audience%20analysis%20dashboard%2C%20demographic%20data%20charts%20and%20graphs%2C%20marketing%20persona%20development%20interface%2C%20clean%20modern%20design%20with%20teal%20color%20scheme&width=600&height=400&seq=target-segment&orientation=landscape'
    },
    {
      icon: 'ri-line-chart-line',
      title: '실시간 성과 분석',
      description: '퍼널의 각 단계별 전환율을 실시간으로 모니터링하고 개선점을 자동으로 제안합니다.',
      image: 'https://readdy.ai/api/search-image?query=Real-time%20analytics%20dashboard%20showing%20marketing%20funnel%20performance%2C%20conversion%20rate%20charts%20and%20KPI%20metrics%2C%20interactive%20data%20visualization%20with%20graphs%20and%20statistics%2C%20modern%20business%20intelligence%20interface%20with%20teal%20highlights&width=600&height=400&seq=analytics&orientation=landscape'
    },
    {
      icon: 'ri-shuffle-line',
      title: 'A/B 테스트 자동화',
      description: '다양한 퍼널 변형을 자동으로 테스트하여 최고 성과를 내는 버전을 찾아냅니다.',
      image: 'https://readdy.ai/api/search-image?query=A%2FB%20testing%20interface%20showing%20split%20test%20results%2C%20comparison%20charts%20between%20different%20marketing%20versions%2C%20automated%20testing%20dashboard%20with%20performance%20metrics%2C%20modern%20UI%20design%20with%20clean%20layout%20and%20teal%20accents&width=600&height=400&seq=ab-test&orientation=landscape'
    },
    {
      icon: 'ri-links-line',
      title: '다채널 통합',
      description: '이메일, 소셜미디어, 광고 플랫폼을 하나의 통합된 퍼널로 연결하여 일관된 고객 경험을 제공합니다.',
      image: 'https://readdy.ai/api/search-image?query=Multi-channel%20marketing%20integration%20showing%20connected%20platforms%2C%20social%20media%20icons%20and%20email%20marketing%20tools%2C%20unified%20dashboard%20with%20various%20marketing%20channels%2C%20modern%20interface%20design%20with%20interconnected%20elements%20and%20teal%20color%20theme&width=600&height=400&seq=integration&orientation=landscape'
    },
    {
      icon: 'ri-settings-3-line',
      title: '자동 최적화',
      description: 'AI가 지속적으로 퍼널 성과를 모니터링하고 자동으로 개선사항을 적용합니다.',
      image: 'https://readdy.ai/api/search-image?query=Automated%20optimization%20system%20with%20AI%20algorithms%2C%20self-improving%20marketing%20funnel%20visualization%2C%20machine%20learning%20optimization%20process%2C%20futuristic%20dashboard%20with%20automated%20controls%20and%20teal%20interface%20elements&width=600&height=400&seq=optimization&orientation=landscape'
    }
  ];

  return (
    <section id="features" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            강력한 AI 마케팅 기능
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            최신 인공지능 기술을 활용하여 마케팅 퍼널의 모든 과정을 자동화하고 최적화합니다
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {features.map((feature, index) => (
            <div key={index} className="flex flex-col lg:flex-row items-center gap-8">
              <div className="lg:w-1/2">
                <img 
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-64 object-cover rounded-lg shadow-lg"
                />
              </div>
              <div className="lg:w-1/2">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${feature.icon} text-2xl text-teal-600`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">{feature.title}</h3>
                <p className="text-gray-600 leading-relaxed">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
